import React from 'react';

const certificates = [
  {
    name: 'Certified Kubernetes Administrator (CKA)',
    authority: 'The Linux Foundation',
    date: '2023',
    image: '/img/Cert01tv.png',
  },
  {
    name: 'AWS Certified Solutions Architect - Associate',
    authority: 'Amazon Web Services',
    date: '2023',
    image: '/img/Cert02tv.png',
  },
  {
    name: 'Microsoft Certified: Azure Fundamentals',
    authority: 'Microsoft',
    date: '2022',
    image: '/img/Cert03tv.png',
  },
  {
    name: 'Google Certified Professional Cloud Architect',
    authority: 'Google Cloud',
    date: '2024',
    image: '/img/Cert04tv.png',
  },
  {
    name: 'OpenSSL Certified Secure Platform',
    authority: 'OpenSSL',
    date: '2024',
    image: '/img/opensslcert1.png',
  },
  {
    name: "Let's Encrypt Certified Hosting Environment",
    authority: "Let's Encrypt",
    date: '2024',
    image: '/img/letsencryptcert1.png',
  },
];

const CertificationSection = () => {
  return (
    <section className="bg-gradient-to-tr from-white to-[#e0f2f1] py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-4xl font-bold text-center mb-12">Certification & Achievement</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
          {certificates.map((cert, index) => (
            <div key={index} className="flex flex-col items-center text-center p-2">
              <div className="h-24 w-full mb-2">
                <img src={cert.image} alt={cert.name} className="h-full w-full object-contain rounded-md"/>
              </div>
              <h3 className="text-sm font-bold mb-1 text-gray-800">{cert.name}</h3>
              <p className="text-xs text-gray-600">{cert.authority}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationSection;